(() => {
  angular
    .module('gm.common.decorators')
    .decorator('aDirective', aDirective);

  function aDirective(
    $delegate,
    $timeout,
    $location,
    $window,
    $route,
    GmyMobileApp
  ) {
    'ngInject';

    const directive = $delegate[0];

    directive.compile = () => (scope, element, attrs) => {
      const delayedRoute = (attrs.gmDelayedRoute && scope.$eval(attrs.gmDelayedRoute))
        ? 300 : 0;

      let href = attrs.href || attrs.ngHref || '';
      const target = attrs.target || '';

      function clickHandler(event) {
        event.stopPropagation();
        event.preventDefault();
        event.isDefaultPrevented = () => false;

        const isHttp = href.match(/^http(s)?:/);

        if (isHttp) {
          if (GmyMobileApp.isMobile()) {
            GmyMobileApp.openExternal(href);
          } else {
            $window.open(href, target || '');
          }
        } else {
          const isAlternateApp = () => {
            let match = true;
            angular.forEach($route.routes, (route) => {
              if (('regexp' in route) && (route.regexp.exec(href))) {
                match = false;
              }
            });
            return match;
          };

          $timeout(() => {
            if (isAlternateApp()) {
              if (element[0] === this) {
                if (target === '_blank') {
                  $window.open(href, target);
                } else {
                  $window.location.href = attrs.href || '';
                }
              } else {
                element.trigger(event);
              }
            } else {
              $location.path(attrs.href || '');
            }
          }, delayedRoute);
        }
      }

      if (href.length > 0) {
        // get rid of any href="#" entries
        href = href.replace(/^#$/, '');

        const isHashPath = href.match(/^#(.*)/);
        const isJavascript = href.match(/^javascript:/);
        const isMail = href.match(/^mailto:/);
        const isTel = href.match(/^tel:/);

        if (!isHashPath && !isJavascript && !isMail && !isTel) {
          element.on('click', clickHandler);
        }

        scope.$on('$destroy', () => {
          element.off('click', clickHandler);
        });
      }
    };

    delete directive.link;

    return $delegate;
  }
})();
